<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="item !== null">
      <v-toolbar color="primary white--text" flat>
        <sabira_icon
          icon="edit_write"
          class="mr-2"
          :strokewidth="3"
          fill="white"
        />
        <v-toolbar-title class="ml-1"> {{ title }} </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="pa-0 ma-0"
        style="margin-left: 0px; min-height: 30rem;"
      >
        <div class="master_grid">
          <div>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <webpage_lookup_users
                    update="wp_user_changed"
                    :selected_id="
                      typeof item.user_id !== 'undefined' &&
                      item.user_id !== null
                        ? item.user_id
                        : null
                    "
                  ></webpage_lookup_users>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="item.subject"
                    outlined
                    label="Predmet sistemske poruke"
                    hide-details
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-textarea
                    v-model="item.message"
                    outlined
                    label="Poruka"
                    hide-details
                    clearable
                  ></v-textarea>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="background">
        <v-btn text @click="close_dialog()">Odustani</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="save_item()">Pošalji</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_users: () => import("@/components/lookups/users"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    item: {
      id: 0,
      user_id: null,
      subject: null,
      message: null,
    },
    title: "Sistemska poruka korisnicima",
    visible: false,
  }),
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
        } else {
          this.item = {
            id: 0,
            user_id: 0,
            subject: null,
            message: null,
          };
        }
      },
      immediate: false,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.item.subject == null || this.item.subject.length == 0) {
          has_errors = true;
          reject("Predmet polje je obavezno.");
        }
        if (this.item.message == null || this.item.message.length == 0) {
          has_errors = true;
          reject("Poruka polje je obavezno.");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_user_changed", (user) => {
        if (typeof user !== "undefined" && user !== null) {
          this.item.user_id = user.id;
        }
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_user_changed");
    },
    close_dialog() {
      this.$webpageEventBus.$emit("close_sys_message_dialog");
    },
    save_item() {
      this.validate()
        .then(() => {
          this.$http({
            method: "POST",
            url: "/sys_messages/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Nova sistemska poruka je kreirana.",
                timeout: 2000,
              });
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
              this.$webpageEventBus.$emit("new_message");
            } else {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message: resp.data.message,
                timeout: 4000,
              });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
};
</script>

<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}
</style>
